export const FLASHING_PATTERN = [
  [200, 1, 1, 1, 1, 1, 1],
  [100, 0, 0, 0, 0, 0, 0],
  [100, 1, 1, 1, 1, 1, 1],
  [200, 0, 0, 0, 0, 0, 0],
];
